import {createActions} from 'redux-actions';
import fetchJson, {postJson, putJson, deleteJson, postForm} from '../fetchJson';
import handleError from '../handleError';
import {replace} from 'connected-react-router';

const actions = createActions(
	'NOTICES_REQUESTED',
	'NOTICES_RETRIEVED',
	'NOTICES_COMMENT_ADDED',
	'NOTICES_ADDING',
	'NOTICES_CHANGED_ADDING',
	'NOTICES_ADDED',
	'NOTICES_ADDING_CANCELLED',
	'NOTICES_DROP_BACKGROUND_IMG_ADDING',
	'NOTICES_REMOVED',
	'NOTICES_EDITING',
	'NOTICES_CHANGED_EDITING',
	'NOTICES_EDITED',
	'NOTICES_EDITED_CANCELLED',
	'NOTICES_DROP_BACKGROUND_IMG_EDITING'
);

export const conditionallyRetrieveNotices = () => (dispatch, getState) => {
	const community = getState().community;
	const notices = getState().notices;

	// If notices disabled, redirect to about page
	if (community && !community.noticesEnabled) {
		return dispatch(replace(`/about/${community.profile.uniqueName}`));
	}

	// Only retrieve notices if the existing loaded notices are not for this community, or are not loaded yet.
	if (community && notices.communityUuid !== community.uuid) {
		dispatch(actions.noticesRequested(community.uuid));

		fetchJson(`/api/community/${community.uuid}/notices`)
			.then(notices => dispatch(actions.noticesRetrieved(notices)))
			.catch(handleError(dispatch));
	}
};

export const persistComment = meta => (dispatch, getState) => {
	const community = getState().community;

	dispatch(actions.noticesCommentAdded(meta));

	postJson(`/api/community/${community.uuid}/notices/${meta.uuid}/comment`, {
		content: meta.newComment
	}).catch(handleError(dispatch));
};

export const persistNotice = () => (dispatch, getState) => {
	const notice = getState().notices.adding;

	dispatch(actions.noticesAdded());

	postForm(`/api/community/${notice.communityUuid}/notices`, notice).catch(handleError(dispatch));
};

export const persistExistingNotice = () => (dispatch, getState) => {
	const notice = getState().notices.editing;

	dispatch(actions.noticesEdited());

	const noticeData = {
		title: notice.title,
		content: notice.content,
		backgroundURL: notice.backgroundURL
	};
	if (notice.image) noticeData['image'] = notice.image;

	postForm(`/api/community/${notice.communityUuid}/notices/${notice.uuid}`, noticeData).catch(
		handleError(dispatch)
	);
};

export const removeNotice = uuid => (dispatch, getState) => {
	const notice = getState().notices.items.find(n => n.uuid === uuid);
	dispatch(actions.noticesRemoved(uuid));

	deleteJson(`/api/community/${notice.communityUuid}/notices/${uuid}`, notice).catch(
		handleError(dispatch)
	);
};

export default {
	...actions,
	conditionallyRetrieveNotices,
	persistComment,
	persistNotice,
	persistExistingNotice,
	removeNotice
};



// WEBPACK FOOTER //
// ./src/community/notices.actions.js